module.exports = __webpack_public_path__ + "static/media/info1.b25732db.png";


//////////////////
// WEBPACK FOOTER
// ./src/info1.png
// module id = 388
// module chunks = 0